<template>
    <section class="my-profile">
        <div class="user-profile">
            <b-form @submit="updateUser" v-if="show">
                <b-form-group label="New password:" label-for="password-1">
                    <b-form-input
                            id="password-1"
                            v-model="userPassword"
                            type="password"
                            minlength="8"
                            required
                            placeholder="Enter new password"
                    ></b-form-input>
                </b-form-group>

                <b-form-group label="New password again:" label-for="password-2">
                    <b-form-input
                            id="password-2"
                            v-model="userNewPassword"
                            type="password"
                            required
                            placeholder="Enter new password again"
                    ></b-form-input>
                </b-form-group>
                <b-button type="submit" variant="primary">Save</b-button>
            </b-form>
        </div>
    </section>
</template>

<script>
export default {
  name: 'PasswordUpdate',
  data () {
    return {
      token: '',
      userPassword: '',
      userNewPassword: '',
      show: false,

      updatedData: {
        token: this.token,
        password: '',
        new_password: ''
      },
      mainProps: { blank: true, blankColor: '#777', width: 75, height: 75, class: 'm1' }
    }
  },
  methods: {
    updatePassword () {
      this.axios.post(
        `/api/password/restore`,
        this.updatedData,
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(response => {
        console.log(response)

        if (response.status === 200) {
          this.userPassword = ''
          this.userNewPassword = ''
          this.$snotify.success(response.data.massage, 'Success', this.$store.state.snotify)
        }
        this.updatedData = {}
      }).catch(err => {
        console.log(err.response)
        this.$snotify.error(err.response.data.error, 'Error', this.$store.state.snotify)
        if (err.response.errors) {
          var errors = Object.values(err.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
          }
        }
      })
    },
    updateUser (e) {
      e.preventDefault()
      this.updatedData = {
        token: this.token,
        password: '',
        new_password: ''
      }

      if (this.userPassword.length || this.userNewPassword) {
        if (this.userPassword.length >= 1 && this.userPassword.length <= 10) {
          this.updatedData.password = this.userPassword
        } else {
          this.$snotify.error('The password value is not between 1 - 10.', 'Error', this.$store.state.snotify)
        }
        if (this.userNewPassword === this.userPassword) {
          this.updatedData.new_password = this.userNewPassword
        } else {
          this.$snotify.error('The new passwords must match.', 'Error', this.$store.state.snotify)
        }
        if (this.updatedData.password.length && this.updatedData.new_password.length) {
          this.updatePassword()
        }
      }
    }
  },
  mounted () {
    this.token = this.$route.query.token
    console.log(this.token)
    this.axios({
      method: 'get',
      url: `/api/password/verified/${this.token}`,
      headers: {}
    }).then(response => {
      this.show = true
      console.log(response)
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<style scoped>
    .user-profile {
        max-width: 600px;
        margin: 1.5rem auto;
        padding: 40px;
        box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
    }
    .user-profile-avatar {
        display: block;
        margin: 25px auto 15px;
    }
</style>
